import React from 'react';
import PropTypes from 'prop-types';

import SurgeIncentive from '../interfaces/surge-incentive-interface';
import ConfirmableLink from '../../shared/confirmable-link';
import ProviderSurgeIncentiveEdit from './provider-surge-incentive-edit-container';
import { formatDate } from '../../../utility/dates';
import ProviderSurgeIncentiveStatus from '../enums/provider-surge-incentive-status';

const ProviderSurgeIncentiveSearchTableRecord = ({
  surgeIncentive,
  surgeIncentiveStatus,
  canBeModified,
  deleteSurgeIncentive
}) => (
  <tr>
    <td>{formatDate(surgeIncentive.start_date)}</td>
    <td>{formatDate(surgeIncentive.end_date)}</td>
    <td>{surgeIncentive.state_code}</td>
    <td>{surgeIncentive.amount}</td>
    <td>
      {canBeModified && (
        <ProviderSurgeIncentiveEdit
          surgeIncentive={surgeIncentive}
          surgeIncentiveStatus={surgeIncentiveStatus}
        />
      )}
    </td>
    <td>
      {canBeModified && (
        <ConfirmableLink
          message={`${
            surgeIncentiveStatus === ProviderSurgeIncentiveStatus.ACTIVE
              ? 'This surge incentive is active.\nDeleting it will set its end date to now.\n'
              : ''
          }Are you sure you want to delete this?`}
          onConfirmation={() =>
            deleteSurgeIncentive({ id: surgeIncentive.provider_incentive_cost_id })
          }
        >
          Delete
        </ConfirmableLink>
      )}
    </td>
  </tr>
);

ProviderSurgeIncentiveSearchTableRecord.propTypes = {
  surgeIncentive: SurgeIncentive,
  surgeIncentiveStatus: PropTypes.string.isRequired,
  canBeModified: PropTypes.bool.isRequired,
  deleteSurgeIncentive: PropTypes.func.isRequired
};

export default ProviderSurgeIncentiveSearchTableRecord;
